/**
 * DownloadAppLink util returns the Solflare app download URL.
 * Future: Accepts additional parameters for dynamic link generation.
 */
export const SOLFLARE_DOWNLOAD_URL =
  'https://solflare.onelink.me/WVZY?pid=website&c=download_apps&af_channel=download_apps&af_dp=solflare://';

/**
 * Returns the Solflare app download URL with dynamic analytics parameters.
 * @param options Optional params for analytics: af_channel (position id), af_sub1 (token info)
 * @returns string
 */
export function getDownloadAppUrl(options?: {
  af_channel?: string; // e.g. 'token_prices', 'token_swap_link', etc.
  af_sub1?: string;    // e.g. 'token_ticker+mint_address'
}): string {
  const base = 'https://solflare.onelink.me/WVZY';
  const params = new URLSearchParams({
    pid: 'website',
    c: 'token_prices',
    af_channel: options?.af_channel || 'token_prices',
  });
  if (options?.af_sub1) {
    params.set('af_sub1', options.af_sub1);
  }
  params.set('af_dp', 'solflare://');

  return `${base}?${params.toString()}`;
}
